type ModuleNamespace = Record<string, unknown>;

declare global {
  var __webpack_require__: ((id: string) => unknown) & { u: (chunkId: string) => string };
  var __webpack_chunk_load__: (chunkId: string) => Promise<unknown>;
  // Read by the development RSC client only, to attribute chunk timings in debug info.
  var __webpack_get_script_filename__: (chunkId: string) => string;
}

export function installBrowserWebpackShim(assetsBaseUrl: () => string): void {
  const loaded = new Map<string, ModuleNamespace>();
  const chunks = new Map<string, Promise<ModuleNamespace>>();
  const requireModule = ((id: string) => {
    const module = loaded.get(id);
    if (!module) throw new Error(`RSC client module "${id}" has not been loaded.`);
    return module;
  }) as typeof globalThis.__webpack_require__;
  requireModule.u = (chunkId) => chunkId;
  const chunkUrl = (chunkId: string) => {
    const filename = globalThis.__webpack_require__.u(chunkId);
    return `${assetsBaseUrl().replace(/\/$/, '')}/${filename.replace(/^\//, '')}`;
  };
  globalThis.__webpack_require__ = requireModule;
  globalThis.__webpack_get_script_filename__ = chunkUrl;
  globalThis.__webpack_chunk_load__ = (chunkId) => {
    let pending = chunks.get(chunkId);
    if (!pending) {
      const url = chunkUrl(chunkId);
      pending = import(/* @vite-ignore */ url).then((module) => {
        loaded.set(chunkId, module as ModuleNamespace);
        return module as ModuleNamespace;
      });
      chunks.set(chunkId, pending);
    }
    return pending;
  };
}

let nodeRequireListener: ((id: string) => void) | null = null;

/** Called for every client module the SSR render requires (used to emit modulepreload hints). */
export function setNodeRequireListener(listener: ((id: string) => void) | null): void {
  nodeRequireListener = listener;
}

export function installNodeWebpackShim(modules: Record<string, ModuleNamespace>): void {
  globalThis.__webpack_require__ = Object.assign(
    (id: string) => {
      const module = modules[id];
      if (!module) throw new Error(`SSR client module "${id}" is missing from the module map.`);
      nodeRequireListener?.(id);
      return module;
    },
    { u: (chunkId: string) => chunkId },
  );
  globalThis.__webpack_chunk_load__ = async () => undefined;
}
